import { Box, Container, Divider, Typography } from '@mui/material';

const rev = (text) => [...text].reverse().join('');

const ReversedText = ({ children }) => (
  <Box
    component="span"
    sx={{ direction: 'rtl', unicodeBidi: 'bidi-override', display: 'block' }}
  >
    {rev(children)}
  </Box>
);

const ObfuscatedEmail = ({ user, domain }) => (
  <Box
    component="span"
    sx={{
      '&::before': { content: `"${user}@"` },
      '&::after':  { content: `"${domain}"` },
      cursor: 'pointer',
    }}
    onClick={() => { window.location = 'mailto:' + user + '@' + domain; }}
    title="E-Mail schreiben"
  />
);

export default function Impressum() {
  return (
    <Container maxWidth="md">
      <Box sx={{ py: 4 }}>
        <Typography variant="h4" gutterBottom>Impressum</Typography>

        <Typography variant="h6" sx={{ mt: 3 }}>Angaben gemäß § 5 TMG</Typography>
        <Typography component="div">
          <ReversedText>Lars Kempkens</ReversedText>
          <ReversedText>An der Mühlwiese 5</ReversedText>
          <ReversedText>63505 Langenselbold</ReversedText>
        </Typography>

        <Typography variant="h6" sx={{ mt: 3 }}>Kontakt</Typography>
        <Typography component="div" sx={{ display: 'flex', gap: 1 }}>
          <span>E-Mail:</span>
          <ObfuscatedEmail user="pfingstturnier" domain="thc-hanau.de" />
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Typography variant="h6">Haftungsausschluss</Typography>

        <Typography variant="subtitle1" sx={{ mt: 2, fontWeight: 'bold' }}>
          Haftung für Inhalte
        </Typography>
        <Typography variant="body2">
          Als Diensteanbieter bin ich gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten
          nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG bin ich als
          Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
          Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
          Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
          Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine
          diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten
          Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werde
          ich diese Inhalte umgehend entfernen.
        </Typography>

        <Typography variant="subtitle1" sx={{ mt: 2, fontWeight: 'bold' }}>
          Haftung für Links
        </Typography>
        <Typography variant="body2">
          Mein Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte ich keinen
          Einfluss habe. Deshalb kann ich für diese fremden Inhalte auch keine Gewähr übernehmen.
          Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber
          der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf
          mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der
          Verlinkung nicht erkennbar. Bei Bekanntwerden von Rechtsverletzungen werde ich derartige
          Links umgehend entfernen.
        </Typography>

        <Typography variant="subtitle1" sx={{ mt: 2, fontWeight: 'bold' }}>
          Urheberrecht
        </Typography>
        <Typography variant="body2">
          Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen
          dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art
          der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen
          Zustimmung des jeweiligen Autors. Downloads und Kopien dieser Seite sind nur für den
          privaten, nicht kommerziellen Gebrauch gestattet. Bei Bekanntwerden von
          Rechtsverletzungen werde ich derartige Inhalte umgehend entfernen.
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Typography variant="h6">Datenschutzhinweis</Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          Diese Website verarbeitet personenbezogene Daten (Namen, E-Mail-Adressen,
          Vereinszugehörigkeiten) ausschließlich zur Durchführung der Turnierorganisation und
          -anmeldung. Eine Weitergabe an Dritte erfolgt nicht. Die Daten werden nach Abschluss
          des jeweiligen Turniers gelöscht. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO
          (Vertragserfüllung). Sie haben jederzeit das Recht auf Auskunft, Berichtigung und
          Löschung Ihrer gespeicherten Daten. Bitte wenden Sie sich dazu an die oben genannte
          E-Mail-Adresse.
        </Typography>
      </Box>
    </Container>
  );
}